/** Logo files live in /public (served from site root). */
export const ACCOUNTS = [
  {
    id: 'zaad',
    label: 'Zaad',
    value: '+252634195333',
    hintKey: 'mobileMoney',
    logo: 'zaad.png',
  },
  {
    id: 'edahab',
    label: 'Edahab',
    value: '+252657555554',
    hintKey: 'mobileMoney',
    logo: 'edahab.png',
  },
  {
    id: 'dara',
    label: 'Darasalam Bank',
    value: '60330769',
    hintKey: 'accountNumber',
    logo: 'darasalam-bank.png',
  },
  {
    id: 'premier',
    label: 'Premier Bank',
    value: '100300490001',
    hintKey: 'accountNumber',
    logo: 'premier-bank.png',
  },
];

/**
 * Hero YouTube video — set REACT_APP_HERO_YOUTUBE_URL in .env
 * (watch, youtu.be, embed, or shorts link).
 */
export const HERO_YOUTUBE_URL = process.env.REACT_APP_HERO_YOUTUBE_URL || '';

/**
 * Footer social links — set REACT_APP_SOCIAL_* in .env or edit URLs below.
 * Links with an empty url are hidden.
 */
export const SOCIAL_LINKS = [
  {
    id: 'facebook',
    url: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/maaliniyohabeen',
    labelKey: 'footer.socialFacebook',
  },
  {
    id: 'instagram',
    url: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/maaliniyohabeen',
    labelKey: 'footer.socialInstagram',
  },
  {
    id: 'x',
    url: process.env.REACT_APP_SOCIAL_X || 'https://x.com/maaliniyohabeen',
    labelKey: 'footer.socialX',
  },
  {
    id: 'youtube',
    url: process.env.REACT_APP_SOCIAL_YOUTUBE || '',
    labelKey: 'footer.socialYoutube',
  },
  {
    id: 'whatsapp',
    url:
      process.env.REACT_APP_SOCIAL_WHATSAPP ||
      'https://wa.me/252634807147',
    labelKey: 'footer.socialWhatsapp',
  },
].filter((link) => Boolean(link.url?.trim()));
